import React, { useState, useEffect, useCallback } from 'react';
import { motion } from "framer-motion";
import './Modal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import useFirestore from '../../hooks/useFirestore';
import { projectStorage, projectFirestore, timestamp } from "../../firebase/config";
import update from "immutability-helper";
import useSound from 'use-sound';
import commentWAV from './../../sounds/comment.wav';
import likesWAV from './../../sounds/likes.wav';

const Modal = ({ selectedImg, setSelectedImg, isSound }) => {
    const [likes, setLikes] = useState(selectedImg.likes);
    const [comment, setComment] = useState("");
    const [commentArray, setCommentArray] = useState(selectedImg.comments);
    const [targetScale, setTargetScale] = useState(1);
    const [commentSound] = useSound(commentWAV, { volume: 0.4 });
    const [likesSound] = useSound(likesWAV, { volume: 0.4 });

    const handleBackdropClick = (e) => {
        if (e.target.classList.contains('backdrop')) {
            setSelectedImg(null);
        }
    }

    const handleLikeClick = (e) => {
        setTargetScale([1, 1.5, 1.5, 1, 1]);
        setLikes(selectedImg.likes + 1)
        isSound && likesSound();
    }

    const handlePostClick = (e) => {
        if (comment !== ''){
            setCommentArray(update(commentArray, { $push: [comment] }))
            isSound && commentSound();
        }
    }

    useEffect(() => {
        const collectionRef = projectFirestore.collection('images');
        collectionRef.doc(selectedImg.id).update({
            comments: commentArray,
            likes: likes
        }).then(() => {
        }
        ).catch((error) => {
            console.log(error)
        })
    }, [commentArray, likes]);

    return (
        <motion.div className="backdrop" onClick={handleBackdropClick}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
        >
            <motion.div className="modal" initial={{ y: "-100vh" }} animate={{ y: "0vh" }} >
                <div className="content">
                    <motion.img className="image" src={selectedImg.url} alt="enlarged pic" />
                    <motion.div className="info">
                        <div className="top">
                            <div className="comments"> {commentArray.map((item, i) => <motion.li key={i} initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}>{item}</motion.li>)}</div>
                        </div>
                        <div className="bottom">
                            <div className="likes">
                                <div>{likes} likes</div>

                                <a className="button" onClick={handleLikeClick}>
                                    <motion.div
                                        animate={{ scale: targetScale }}
                                        transition={{ duration: 0.5 }}>
                                        <FontAwesomeIcon icon={faHeart} /></motion.div></a>
                            </div>
                            <div>
                                <form className="comments-form">
                                    <textarea className="text-input" placeholder="Write a Comment" name="Write a Comment" cols="40" rows="1" onChange={(e) => setComment(e.target.value)}></textarea>

                                    <a className="button" onClick={handlePostClick}> Post </a>
                                </form>
                            </div>

                        </div>
                    </motion.div>
                </div>
            </motion.div>
        </motion.div >
    )
}

export default Modal;